import { Location } from "@angular/common";
import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { map, Observable } from "rxjs";

import { SubDomainService } from "services/sub-domain.service";
import { AuthFacade } from "state/auth.facade";

export const OktaAuthGuard: CanActivateFn = (): boolean | Observable<boolean> => {
  const subDomainService = inject(SubDomainService);
  const authFacade = inject(AuthFacade);
  const location = inject(Location);

  const subDomainName = subDomainService.subDomain;
  const destinationPath = location.path();

  if (subDomainName) {
    // Let auth facade do external redirects
    return authFacade
      .authenticateOkta$(subDomainName, destinationPath)
      .pipe(map(({ success }) => !success));
  } else {
    // Continue navigation
    return true;
  }
};
